// extracted by mini-css-extract-plugin
module.exports = {"gallery":"MediaGallery_gallery__3OQXj","notificationContainer":"MediaGallery_notificationContainer__21JUG"};